import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Callback3dsVisa = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const app = searchParams.get("app");
    const stepupresponse = searchParams.get("stepupresponse");
    const stepupauthcode = searchParams.get("stepupauthcode");

    console.log(app);
    console.log(stepupresponse);

    if (!app) return;

    const deepLinkParams = new URLSearchParams();
    if (stepupresponse) {
      deepLinkParams.set("stepupresponse", stepupresponse);
    }
    if (stepupauthcode) {
      deepLinkParams.set("stepupauthcode", stepupauthcode);
    }

    const deepLink = `${"managemii://3dsActivationResult"}?${deepLinkParams.toString()}`;
    console.log(deepLink);

    window.location.href = deepLink;
  }, [location.search]);

  return <div></div>;
};

export default Callback3dsVisa;
